import React from "react";
import PropTypes from "prop-types";
import { Card, Typography, Backdrop, Slide, Portal } from "@mui/material";
import MDButton from "components/MDButton";
import { usePermissions } from "context"; // [NEW]

function RBACRestriction({
    open,
    onClose,
    featureName = "This action",
    roleRequired = "Higher Role",
    message
}) {
    const { role: currentRole } = usePermissions();
    return (
        <Portal>
            <Backdrop
                open={open}
                sx={{
                    zIndex: (t) => t.zIndex.modal + 3000, // Very high z-index
                    backgroundColor: "rgba(0,0,0,0.5)",
                    backdropFilter: "blur(4px)",
                }}
                onClick={onClose}
            >
                <Slide direction="up" in={open} mountOnEnter unmountOnExit>
                    <Card
                        onClick={(e) => e.stopPropagation()}
                        sx={{
                            p: 4,
                            maxWidth: 460,
                            width: "90%",
                            borderRadius: "16px",
                            textAlign: "center",
                            backgroundColor: "rgba(255,255,255,0.95)",
                            boxShadow: "0 8px 32px rgba(0,0,0,0.2)",
                        }}
                    >
                        <Typography variant="h6" sx={{ mb: 1, fontWeight: 700 }}>
                            Role Upgrade Required
                        </Typography>

                        <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
                            {message ? message : (
                                <>
                                    You are currently added to this workspace as a <strong>{currentRole || "User"}</strong>.
                                    {featureName} is not allowed.
                                    <br /><br />
                                    Please ask your Workspace Owner to grant you the <strong>{roleRequired}</strong> role or higher to perform this action.
                                </>
                            )}
                        </Typography>

                        <MDButton
                            variant="contained"
                            color="accent"
                            size="medium"
                            onClick={onClose}
                            sx={{ px: 4, py: 1.2, fontWeight: 600, width: "auto", minWidth: "180px" }}
                        >
                            UNDERSTOOD
                        </MDButton>
                    </Card>
                </Slide>
            </Backdrop>
        </Portal>
    );
}

RBACRestriction.propTypes = {
    open: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
    featureName: PropTypes.string,
    roleRequired: PropTypes.string,
    message: PropTypes.string, // [NEW]
};

export default RBACRestriction;
